export default __webpack_public_path__ + "static/media/receita-despesas.53d59ada.png";